import { EMPTY_OBJECT } from '../../../../../../constants/common'
import {
  DragDropDraggableItem,
  DRAGGING_KEEP_IN_PLACE_STYLE,
} from '../../../../../DragDrop'
import { useCalendarGridItemHandlers } from '../../../../CalendarGrid.hooks'
import { getIsCalendarGridPinnedSecondaryLabelClickable } from '../../../../CalendarGrid.utils'
import { CalendarGridItemTrigger } from '../../../../CalendarGridItemTrigger'
import { CalendarGridWeekBlock } from '../../../CalendarGridWeekBlock'

import {
  getHasCalendarGridGroupSeveralLanes,
  getIsCalendarGridTimedItemDragDisabled,
} from './CalendarGridWeekGroupDraggableBlock.utils'

import * as styles from './CalendarGridWeekGroupDraggableBlock.module.css'

function CalendarGridWeekGroupDraggableBlock({
  blockProps = EMPTY_OBJECT,
  canMoveItemsInTime,
  item = EMPTY_OBJECT,
  laneCount,
  onClickItem,
  onClickSecondaryLabel,
}) {
  const { handleClickSecondaryLabel } = useCalendarGridItemHandlers({
    isSecondaryLabelClickable: getIsCalendarGridPinnedSecondaryLabelClickable({
      item,
      onClickSecondaryLabel,
    }),
    item,
    onClickItem,
    onClickSecondaryLabel,
  })

  const { style } = blockProps

  const { hint, id, secondaryLabel, title } = item

  return (
    <DragDropDraggableItem
      keepInPlace
      className={styles.CalendarGridWeekGroupDraggableBlock}
      draggableProps={{
        data: { item },
        disabled: getIsCalendarGridTimedItemDragDisabled({
          canMoveItemsInTime,
          item,
        }),
      }}
      draggingStyle={DRAGGING_KEEP_IN_PLACE_STYLE}
      id={id}
      style={style}
    >
      <CalendarGridItemTrigger
        Trigger={CalendarGridWeekBlock}
        item={item}
        triggerProps={{
          ...blockProps,
          className: styles.block,
          hint,
          isHintDetailed: getHasCalendarGridGroupSeveralLanes(laneCount),
          qaContext: id,
          secondaryLabel,
          title,
          onClickSecondaryLabel: handleClickSecondaryLabel,
        }}
        onClickItem={onClickItem}
      />
    </DragDropDraggableItem>
  )
}

export default CalendarGridWeekGroupDraggableBlock
